<template>
  <el-dialog :visible.sync="dialogVisible" title="查看学段年级" custom-class="custom-dialog" :close-on-click-modal="false"
    @opened="dialogOpen" @closed="dialogClose" width="490px" append-to-body>
    <el-form ref="form" :model="form" :inline="true" label-width="80px" class="demo-form-inline">

        <el-table
            :data="data"
            v-loading="loading"
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            style="width: 100%;margin-bottom: 20px;"
            border>
            <!-- <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column> -->
            <el-table-column prop="gradeName" label="学段学年名称"></el-table-column>
            <el-table-column fixed="right" label="操作"  width="80">
                <template slot-scope="scope">
                    <el-button style="color: red" @click.native.prevent="del(scope.row)"
                        type="text"
                        size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

    </el-form>
  </el-dialog>
</template>
<script>

import http from '../../../../../../common/http';

export default {
  name: 'gradeInfo',
  components: {},
  props: {
    deptId: {
      type: String,
      default() {
        return ""
      }
    },
    esId: {
      type: String,
      default() {
        return ""
      }
    },
    value: Boolean
  },
  data() {
    return {
      loading: false,
      loadingText: "",
      dialogVisible: false,
      form: {
        id: "",
        gradeNames: [],
      },
      data: []
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
  },
  methods: {
    dialogOpen() {
      // 初始值
      this.form.gradeNames = []
      this.data = []

      // 获取数据
      this.getData()
    },
    // 获取设置学段学年与学年数据列表
    getData() {
      let url = this.archiveSegradeListUrl
      let data = {
        deptId: this.deptId,
        esId: this.esId,
      }
      // console.log(JSON.stringify(data))
      // return;
      
      this.loading=true
      this.loadingText = "数据加载中..."
      this.apiPost(url, data).then((res) => {
        if (res.status == 200) {
          this.data = res.data.setGradeList
        } else {
          this.$commonFn.showTip(res.message, 3)
        }
        this.loading = false
      }, (err) => {
        console.log(err);
        this.loading = false
      });
    },
    //删除
    del(data){
        this.form.id = data.id;
        this.$commonFn.showConfirm(this.delSuccess);
    },
    delSuccess(){
      let url = this.archiveSegradeRemoveUrl;
      let data = {
          id:this.form.id
      };

      this.loading=true
      this.loadingText = "数据删除中..."
      this.apiPost(url, data).then((res) => {
        if (res.status == 200) {
          this.$commonFn.showTip(res.message, 1)
          this.getData()
        } else {
          this.$commonFn.showTip(res.message, 3)
        }
        this.loading = false
      }, (err) => {
        console.log(err);
        this.loading = false
      });
    },
    dialogClose() {
      this.$refs.form.resetFields()
      this.dialogVisible = false
    }
  },
  mixins: [http]
}
</script>


// WEBPACK FOOTER //
// src/components/page/sys/dept/setgrade/components/gradeInfo.vue